import React from "react";
import type { TypeCardProps } from "./CardTypes";
import CardHybrid from "./CardHybrid";

/**
 * @link https://seeds.sproutsocial.com/components/card/
 *
 * Card automatically routes between the Tailwind implementation (preferred)
 * and the styled-components implementation (for consumers using system props,
 * BORDER-mixin props, or a styled() extension).
 *
 * Cards with role='presentation' are non-interactive for accessibility compliance.
 * Use role='button' for interactive Cards.
 *
 * Avoid nesting interactive content inside a Card with role='button'.
 *
 * Interactive content: "a", "audio", "button", "embed", "iframe", "img", "input", "label", "select", "textarea", "video"
 * @see https://html.spec.whatwg.org/multipage/dom.html#interactive-content
 *
 * @example
 * // Interactive Card
 * <Card role="button" onClick={_onClick}>
 *   <Text>Click this card</Text>
 * </Card>
 *
 * @example
 * // Presentation Card with interactive children
 * <Card role="presentation">
 *   <Text>This card is not interactive</Text>
 *   <Link href="/details">But this link is</Link>
 * </Card>
 */
const Card = React.forwardRef<HTMLDivElement, TypeCardProps>((props, ref) => (
  <CardHybrid {...props} ref={ref} />
));

Card.displayName = "Card";

export default Card;
